import { LazyLottie } from "./LazyLottie";
import mediaLoader from "/src/assets/animation-json/media-loader.json";

export const LottiPlay = ({animateJSON, ...props}) => {
    return <LazyLottie className="image-loader" style={{ ...props.style }} animationData={animateJSON} loop={true} />
}

// default props
LottiPlay.defaultProps = {
    animateJSON: mediaLoader
};
 